import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "library-author";

export type library_author_list = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    category_library?: string;
    start_date?: string;
    end_date?: string;
}
export type create_library_author = {
    library_author_name: string;
    id_library_author?: number | null
}
export class LibraryAuthorApi extends BaseAPI {
    static list(params: library_author_list): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, { params: params })
    }
    static create(body: create_library_author): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_library_type: number, body: create_library_author): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_library_type}`, body)
    }
    static delete(id_library_type: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_library_type}`)
    }
}